import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, TargetIcon, UserIcon, DatabaseIcon } from 'lucide-react';
export function SystemSection() {
  const phases = [{
    number: 'FASE 1',
    icon: <TargetIcon className="w-5 h-5 md:w-6 md:h-6 text-emerald" data-id="element-33" />,
    title: 'ATRACCIÓN DE BUYERS Y SELLERS',
    desc: 'Leads exclusivos de compradores con pre-aprobación activa y vendedores con motivación real en tu zona de servicio.'
  }, {
    number: 'FASE 2',
    icon: <UserIcon className="w-5 h-5 md:w-6 md:h-6 text-emerald" data-id="element-34" />,
    title: 'MARCA PERSONAL DE AUTORIDAD',
    desc: 'Te posicionamos como el agente experto de referencia en tu área. Contenido de mercado local. Reseñas de clientes anteriores. Presencia que genera confianza antes del primer contacto.'
  }, {
    number: 'FASE 3',
    icon: <DatabaseIcon className="w-5 h-5 md:w-6 md:h-6 text-emerald" data-id="element-35" />,
    title: 'SISTEMA DE REACTIVACIÓN DE BASE',
    desc: 'Reactivamos tu base de datos de clientes pasados con secuencias automáticas de WhatsApp y Email que generan referidos y transacciones de repeat business.'
  }];
  return <section className="py-20 md:py-24 px-5 md:px-8 relative overflow-hidden" data-id="element-36">
      <div className="absolute top-1/2 right-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-emerald/5 rounded-full blur-[100px] md:blur-[120px] pointer-events-none translate-x-1/2 -translate-y-1/2" data-id="element-37" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-gold tracking-tight" data-id="element-40">
            La Cura — Sistema A.C.E.™ Real Estate
          </h2>
          <div className="w-16 md:w-24 h-1 bg-emerald/20 mx-auto mt-6 rounded-full" data-id="element-41" />
        </motion.div>

        <div className="space-y-6 md:space-y-8" data-id="element-42">
          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col md:flex-row gap-4 md:gap-6 bg-dark-200/50 border border-dark-100 p-6 md:p-8 rounded-lg items-start" data-id="element-43">
              <div className="flex items-center gap-4 md:w-1/3 shrink-0" data-id="element-44">
                <div className="bg-emerald/10 p-3 rounded-full shrink-0" data-id="element-45">
                  {phase.icon}
                </div>
                <div data-id="element-46">
                  <span className="text-emerald font-bold text-xs md:text-sm tracking-wider block mb-1" data-id="element-47">
                    {phase.number}
                  </span>
                  <h3 className="text-base md:text-lg font-bold text-white leading-tight" data-id="element-48">
                    {phase.title}
                  </h3>
                </div>
              </div>

              <div className="md:w-2/3 flex items-start gap-3 md:gap-4 mt-2 md:mt-0" data-id="element-49">
                <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mt-0.5" data-id="element-50" />
                <p className="text-gray-300 leading-relaxed text-sm md:text-base" data-id="element-51">
                  {phase.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}